import { IOffer } from '../../types/offer';
import { EGallerySection, IGalleryItem } from '../../types/redux/gallery';
import { GALLERY_SECTIONS_CONFIG } from './constants';

export function prepareNewbuildingImages({ newbuilding }: IOffer): IGalleryItem | null {
  if (!newbuilding || !newbuilding.images || newbuilding.images.length === 0) {
    return null;
  }

  return {
    ...GALLERY_SECTIONS_CONFIG[EGallerySection.JKGallery],
    media: newbuilding.images,
  };
}
